import { SVGIconRoot, __objRest, __spreadValues } from "./armor-icons-T53TEEG3.js";

// src/components/SVGIcon/SVGIcon.tsx
import React from "react";
import { useTheme, token } from "@deliveryhero/armor-system";
var SVGIcon = function SVGIcon(_a) {
  var _b = _a,
    children = _b.children,
    title = _b.title,
    viewBox = _b.viewBox,
    width = _b.width,
    height = _b.height,
    color = _b.color,
    restProps = __objRest(_b, ["children", "title", "viewBox", "width", "height", "color"]);
  var small = restProps.small,
    medium = restProps.medium,
    large = restProps.large;
  var hasSize = small || medium || large;
  var theme = useTheme();
  var defaultSize = "".concat(token("action.sizing.tiny", 24)({
    theme: theme
  }), "px");
  return /* @__PURE__ */React.createElement(SVGIconRoot, __spreadValues({
    viewBox: viewBox,
    focusable: "false",
    color: color,
    iconWidth: hasSize ? defaultSize : width,
    iconHeight: hasSize ? defaultSize : height
  }, restProps), !!title && /* @__PURE__ */React.createElement("title", null, title), children);
};
var SVGIconGroup = function SVGIconGroup(_ref) {
  var children = _ref.children;
  return /* @__PURE__ */React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, children);
};
var SVGIconPath = function SVGIconPath(_ref2) {
  var d = _ref2.d,
    transform = _ref2.transform;
  return /* @__PURE__ */React.createElement("path", {
    d: d,
    transform: transform,
    fill: "currentColor"
  });
};
SVGIcon.defaultProps = {
  display: "inline-block",
  height: "1em",
  width: "1em",
  viewBox: "0 0 24 24"
};
export { SVGIcon, SVGIconGroup, SVGIconPath };